import React from "react";
import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import Features from "../components/Features"
import Stats from "../components/Stats";
import StepsSection from "../components/StepsSection";
import Faqs from "../components/Faqs";
import Footer from "../components/Footer"
import Products from "../components/Products";
import WhatWeDo from "../components/WhatWeDo";
import "../styles/navbar.css"
import Contact from "../components/Contact";

export default function Home() {
  return (
    <div className="home">
      <Navbar />
      <section id="home"><HeroSection /></section>
      <section id="stats"><Stats /></section>
      <section id="whatwedo"><WhatWeDo /></section>
      <section id="features"><Features /></section>
      <section id="products"><Products /></section>
      <section id="steps"><StepsSection /></section>
      <section id="faqs"><Faqs /></section>
      <section id="contact"><Contact /></section>
      <Footer />
    </div>
  );
}
